import { render } from "./JoinRoom.vue?vue&type=template&id=5d4ab518&scoped=true&lang=pug"
import script from "./JoinRoom.vue?vue&type=script&lang=js"
export * from "./JoinRoom.vue?vue&type=script&lang=js"

import "./JoinRoom.vue?vue&type=style&index=0&id=5d4ab518&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4ab518"]])

export default __exports__